import type { DeviationFE, DeviationSeverityFE } from 'domain/vehicle';

export const SEVERITY_ORDER: DeviationSeverityFE[] = ['FATAL', 'ERROR', 'WARNING', 'INFO', 'UNKNOWN', 'INVALID'];

const CRITICAL_SEVERITIES: DeviationSeverityFE[] = ['FATAL', 'ERROR', 'WARNING'];

export const getSeverityRank = (severity: DeviationSeverityFE): number => {
    const rank = SEVERITY_ORDER.indexOf(severity);
    return rank === -1 ? SEVERITY_ORDER.length : rank;
};

export const compareSeverity = (a: DeviationSeverityFE, b: DeviationSeverityFE): number =>
    getSeverityRank(a) - getSeverityRank(b);

export const getTopCriticalSeverity = (deviations: DeviationFE[] | undefined): DeviationSeverityFE | undefined =>
    CRITICAL_SEVERITIES.find(severity => deviations?.some(deviation => deviation.severity === severity));

export type SeverityLevelToken = 'fatal' | 'error' | 'warning' | 'info' | 'resolved';

const SEVERITY_TOKENS: Partial<Record<DeviationSeverityFE, SeverityLevelToken>> = {
    FATAL: 'fatal',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

export const severityLevelToken = (
    severity: DeviationSeverityFE,
    opts?: { isResolved?: boolean }
): SeverityLevelToken | undefined => {
    if (opts?.isResolved) {
        return 'resolved';
    }

    return SEVERITY_TOKENS[severity];
};
